export default __webpack_public_path__ + "static/media/ger-flag.3f29dd71.svg";